import React, { useEffect, useState, useCallback } from 'react'
import axios from 'axios'
const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

function PhIcon({ name, size=16, color="currentColor" }: any) {
  return <i className={`ph-bold ph-${name}`} style={{ fontSize:size, color, lineHeight:1 }} aria-hidden="true"/>
}

const fmtHora = (d:string) => d ? new Date(d).toLocaleString('pt-BR') : '—'

const TIPOS:any = {
  bloqueio:     { label:'Bloqueio',      cor:'#ef4444', icon:'lock' },
  desbloqueio:  { label:'Desbloqueio',   cor:'#22c55e', icon:'lock-open' },
  alerta_regra: { label:'Alerta Regra',  cor:'#f59e0b', icon:'bell-ringing' },
  comando:      { label:'Comando',       cor:'#8b5cf6', icon:'terminal' },
  sistema:      { label:'Sistema',       cor:'#0ea5e9', icon:'gear-six' },
}

export default function Auditoria() {
  const [registros, setRegistros] = useState<any[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [filtroTipo, setFiltroTipo] = useState('')
  const [filtroOrigem, setFiltroOrigem] = useState('')
  const [busca, setBusca] = useState('')
  const [page, setPage] = useState(1)
  const [sel, setSel] = useState<any>(null)
  const limit = 50

  const carregar = useCallback(async () => {
    setLoading(true)
    try {
      const params:any = { page, limit }
      if (filtroTipo) params.tipo = filtroTipo
      if (filtroOrigem) params.origem = filtroOrigem
      const r = await axios.get(`${API}/auditoria`, { params })
      setRegistros(r.data.registros)
      setTotal(r.data.total)
    } catch {}
    finally { setLoading(false) }
  }, [page, filtroTipo, filtroOrigem])

  useEffect(() => {
    if (!document.querySelector('#phosphor-bold')) {
      const l = document.createElement('link')
      l.id = 'phosphor-bold'; l.rel = 'stylesheet'
      l.href = 'https://unpkg.com/@phosphor-icons/web@2.1.1/src/bold/style.css'
      document.head.appendChild(l)
    }
    carregar()
  }, [carregar])

  const filtrados = registros.filter(r =>
    !busca || r.ativo_nome?.toLowerCase().includes(busca.toLowerCase()) ||
    r.placa?.toLowerCase().includes(busca.toLowerCase()) ||
    r.usuario_nome?.toLowerCase().includes(busca.toLowerCase()) ||
    r.acao?.toLowerCase().includes(busca.toLowerCase()) ||
    r.regra_nome?.toLowerCase().includes(busca.toLowerCase())
  )

  return (
    <div style={{ padding:24, height:'100%', overflowY:'auto', background:'#0d1117' }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:20, fontWeight:700, color:'#f1f5f9', margin:0, display:'flex', alignItems:'center', gap:10 }}>
            <PhIcon name="clipboard-text" size={22} color="#0ea5e9"/>
            Auditoria
          </h2>
          <p style={{ fontSize:12, color:'#475569', marginTop:4 }}>{total} registros no total</p>
        </div>
        <button onClick={carregar}
          style={{ background:'#1a2744', border:'1px solid #2d4166', borderRadius:8,
            color:'#94a3b8', cursor:'pointer', padding:'8px 14px', fontSize:12,
            display:'flex', alignItems:'center', gap:6, fontFamily:'Inter' }}>
          <PhIcon name="arrow-clockwise" size={14}/>Atualizar
        </button>
      </div>

      {/* Filtros */}
      <div style={{ display:'flex', gap:10, marginBottom:16, flexWrap:'wrap' }}>
        <input value={busca} onChange={e=>setBusca(e.target.value)}
          placeholder="Buscar ativo, usuário, ação..."
          style={{ flex:1, minWidth:200, padding:'8px 12px', borderRadius:8,
            border:'1px solid #2d4166', background:'#111827', color:'#f1f5f9', fontSize:12, fontFamily:'Inter' }}/>
        <select value={filtroTipo} onChange={e=>{setFiltroTipo(e.target.value);setPage(1)}}
          style={{ padding:'8px 12px', borderRadius:8, border:'1px solid #2d4166',
            background:'#111827', color:'#f1f5f9', fontSize:12, fontFamily:'Inter' }}>
          <option value="">Todos os tipos</option>
          {Object.entries(TIPOS).map(([k,v]:any) => (
            <option key={k} value={k}>{v.label}</option>
          ))}
        </select>
        <select value={filtroOrigem} onChange={e=>{setFiltroOrigem(e.target.value);setPage(1)}}
          style={{ padding:'8px 12px', borderRadius:8, border:'1px solid #2d4166',
            background:'#111827', color:'#f1f5f9', fontSize:12, fontFamily:'Inter' }}>
          <option value="">Todas origens</option>
          <option value="usuario">Usuário</option>
          <option value="sistema">Sistema</option>
        </select>
      </div>

      {/* Tabela */}
      <div style={{ background:'#111827', border:'1px solid #1e2d45', borderRadius:14, overflow:'hidden' }}>
        <table style={{ width:'100%', borderCollapse:'collapse' }}>
          <thead>
            <tr style={{ background:'#1a2744', borderBottom:'1px solid #1e2d45' }}>
              {['Tipo','Ação','Ativo','Usuário/Origem','Regra','Data/Hora',''].map(h=>(
                <th key={h} style={{ padding:'10px 14px', fontSize:10, color:'#475569',
                  fontWeight:700, textAlign:'left', textTransform:'uppercase', letterSpacing:'0.5px' }}>
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} style={{ textAlign:'center', padding:40, color:'#475569' }}>
                <PhIcon name="circle-notch" size={24} color="#0ea5e9"/>
              </td></tr>
            ) : !filtrados.length ? (
              <tr><td colSpan={7} style={{ textAlign:'center', padding:40, color:'#475569', fontSize:13 }}>
                <PhIcon name="clipboard-text" size={32} color="#334155"/>
                <div style={{ marginTop:10 }}>Nenhum registro encontrado</div>
              </td></tr>
            ) : filtrados.map((r,i) => {
              const t = TIPOS[r.tipo] || { label:r.tipo, cor:'#94a3b8', icon:'circle' }
              return (
                <tr key={r.id} onClick={()=>setSel(r)}
                  style={{ borderBottom:'1px solid #1e2d45', cursor:'pointer',
                    background: i%2===0?'transparent':'rgba(255,255,255,0.01)',
                    transition:'background 0.1s' }}
                  onMouseEnter={e=>(e.currentTarget as HTMLElement).style.background='rgba(14,165,233,0.05)'}
                  onMouseLeave={e=>(e.currentTarget as HTMLElement).style.background=i%2===0?'transparent':'rgba(255,255,255,0.01)'}>
                  <td style={{ padding:'10px 14px' }}>
                    <span style={{ display:'flex', alignItems:'center', gap:6,
                      background:`${t.cor}18`, borderRadius:6, padding:'3px 8px',
                      width:'fit-content', fontSize:11, fontWeight:600, color:t.cor }}>
                      <PhIcon name={t.icon} size={12} color={t.cor}/>
                      {t.label}
                    </span>
                  </td>
                  <td style={{ padding:'10px 14px', fontSize:12, color:'#e2e8f0', fontWeight:500 }}>
                    {r.acao}
                  </td>
                  <td style={{ padding:'10px 14px' }}>
                    {r.ativo_nome ? (
                      <div>
                        <div style={{ fontSize:12, color:'#f1f5f9', fontWeight:600 }}>{r.ativo_nome}</div>
                        {r.placa && <div style={{ fontSize:10, color:'#475569', fontFamily:'monospace' }}>{r.placa}</div>}
                      </div>
                    ) : <span style={{ color:'#334155' }}>—</span>}
                  </td>
                  <td style={{ padding:'10px 14px' }}>
                    {r.origem === 'sistema' ? (
                      <span style={{ display:'flex', alignItems:'center', gap:5, fontSize:11,
                        color:'#0ea5e9', background:'#0ea5e918', borderRadius:6, padding:'2px 8px', width:'fit-content' }}>
                        <PhIcon name="gear-six" size={11} color="#0ea5e9"/>
                        Sistema
                      </span>
                    ) : (
                      <div>
                        <div style={{ fontSize:12, color:'#f1f5f9' }}>{r.usuario_nome||'—'}</div>
                        {r.ip && <div style={{ fontSize:10, color:'#334155', fontFamily:'monospace' }}>{r.ip}</div>}
                      </div>
                    )}
                  </td>
                  <td style={{ padding:'10px 14px', fontSize:11, color:'#64748b' }}>
                    {r.regra_nome || '—'}
                  </td>
                  <td style={{ padding:'10px 14px', fontSize:11, color:'#64748b', whiteSpace:'nowrap' }}>
                    {fmtHora(r.criado_em)}
                  </td>
                  <td style={{ padding:'10px 14px' }}>
                    <PhIcon name="caret-right" size={14} color="#334155"/>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      {total > limit && (
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:16 }}>
          <button disabled={page===1} onClick={()=>setPage(p=>p-1)}
            style={{ background:'#1a2744', border:'1px solid #2d4166', borderRadius:8,
              color: page===1?'#334155':'#94a3b8', cursor:page===1?'not-allowed':'pointer',
              padding:'6px 14px', fontSize:12, fontFamily:'Inter', display:'flex', alignItems:'center', gap:6 }}>
            <PhIcon name="caret-left" size={13}/>Anterior
          </button>
          <span style={{ padding:'6px 14px', fontSize:12, color:'#64748b' }}>
            Página {page} de {Math.ceil(total/limit)}
          </span>
          <button disabled={page>=Math.ceil(total/limit)} onClick={()=>setPage(p=>p+1)}
            style={{ background:'#1a2744', border:'1px solid #2d4166', borderRadius:8,
              color:page>=Math.ceil(total/limit)?'#334155':'#94a3b8',
              cursor:page>=Math.ceil(total/limit)?'not-allowed':'pointer',
              padding:'6px 14px', fontSize:12, fontFamily:'Inter', display:'flex', alignItems:'center', gap:6 }}>
            Próxima<PhIcon name="caret-right" size={13}/>
          </button>
        </div>
      )}

      {/* Modal Detalhes */}
      {sel && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', zIndex:2000,
          display:'flex', alignItems:'center', justifyContent:'center' }}
          onClick={()=>setSel(null)}>
          <div style={{ background:'#1a2744', border:'1px solid #2d4166', borderRadius:16,
            width:480, maxHeight:'80vh', overflowY:'auto',
            boxShadow:'0 20px 60px rgba(0,0,0,0.6)' }}
            onClick={e=>e.stopPropagation()}>
            {(() => {
              const t = TIPOS[sel.tipo] || { label:sel.tipo, cor:'#94a3b8', icon:'circle' }
              return (<>
                <div style={{ background:`${t.cor}18`, borderBottom:`1px solid ${t.cor}33`, padding:'16px 20px',
                  display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                    <div style={{ background:`${t.cor}33`, borderRadius:10, padding:8 }}>
                      <PhIcon name={t.icon} size={20} color={t.cor}/>
                    </div>
                    <div>
                      <div style={{ fontSize:11, color:t.cor, fontWeight:700, textTransform:'uppercase' }}>{t.label}</div>
                      <div style={{ fontSize:14, fontWeight:700, color:'#f1f5f9', marginTop:2 }}>{sel.acao}</div>
                    </div>
                  </div>
                  <button onClick={()=>setSel(null)}
                    style={{ background:'none', border:'none', color:'#64748b', cursor:'pointer' }}>
                    <PhIcon name="x" size={16}/>
                  </button>
                </div>
                <div style={{ padding:'16px 20px' }}>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:12 }}>
                    {[
                      { label:'Data/Hora', valor:fmtHora(sel.criado_em), icon:'clock' },
                      { label:'Origem', valor:sel.origem==='sistema'?'Sistema Automático':'Usuário', icon:'user' },
                      { label:'Ativo', valor:sel.ativo_nome||(sel.detalhes?.ativo_nome||'—'), icon:'car' },
                      { label:'Placa', valor:sel.placa||(sel.detalhes?.placa||'—'), icon:'identification-card' },
                      { label:'Usuário', valor:sel.usuario_nome||'Sistema', icon:'user-circle' },
                      { label:'IP', valor:sel.ip||'—', icon:'globe' },
                    ].map((d,i)=>(
                      <div key={i} style={{ background:'#0d1b2e', borderRadius:8, padding:'8px 12px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:5, marginBottom:3 }}>
                          <PhIcon name={d.icon} size={11} color="#475569"/>
                          <span style={{ fontSize:10, color:'#475569' }}>{d.label}</span>
                        </div>
                        <div style={{ fontSize:12, fontWeight:600, color:'#f1f5f9' }}>{d.valor}</div>
                      </div>
                    ))}
                  </div>
                  {sel.regra_nome && (
                    <div style={{ background:'#0d1b2e', borderRadius:8, padding:'8px 12px', marginBottom:8 }}>
                      <div style={{ fontSize:10, color:'#475569', marginBottom:3 }}>Regra</div>
                      <div style={{ fontSize:13, color:'#f59e0b', fontWeight:600 }}>{sel.regra_nome}</div>
                    </div>
                  )}
                  {sel.detalhes && (
                    <div style={{ background:'#0d1b2e', borderRadius:8, padding:'8px 12px' }}>
                      <div style={{ fontSize:10, color:'#475569', marginBottom:6 }}>Detalhes</div>
                      <pre style={{ fontSize:11, color:'#94a3b8', margin:0, whiteSpace:'pre-wrap', fontFamily:'monospace' }}>
                        {JSON.stringify(typeof sel.detalhes==='string'?JSON.parse(sel.detalhes):sel.detalhes, null, 2)}
                      </pre>
                    </div>
                  )}
                </div>
              </>)
            })()}
          </div>
        </div>
      )}
    </div>
  )
}
